import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useFinanceStream, type FinanceChange } from 'sama-shared';
import { partnerPayoutsApi } from '../api/partnerPayoutsApi';

type Tag = Parameters<typeof partnerPayoutsApi.util.invalidateTags>[0][number];

// `id` ausente (resync) solo invalida listas; los detalles abiertos se refrescan con su evento.
const tagsFor = ({ entity, id }: FinanceChange): Tag[] => {
  switch (entity) {
    case 'partner-invoice':
      return [
        { type: 'PartnerInvoice', id: 'LIST' },
        { type: 'PartnerInvoice', id: 'CURRENT' },
        ...(id ? [{ type: 'PartnerInvoice' as const, id }] : []),
      ];
    case 'partner-payout':
      return [
        { type: 'PartnerPayout', id: 'LIST' },
        { type: 'PartnerSettlement', id: 'LIST' },
        { type: 'PartnerDebt', id: 'SUMMARY' },
        ...(id ? [{ type: 'PartnerPayout' as const, id }] : []),
      ];
    case 'payout':
      // getPayouts/getPayoutById (billingAccountsApi) cuelgan del tag genérico 'Finance'.
      return ['Finance'];
  }
};

/** Mantiene facturas, cobros y pagos del partner al día vía SSE de finanzas. */
export const useFinanceLiveSync = (enabled: boolean) => {
  const dispatch = useDispatch();
  const onInvalidate = useCallback(
    (changes: FinanceChange[]) =>
      dispatch(partnerPayoutsApi.util.invalidateTags(changes.flatMap(tagsFor))),
    [dispatch]
  );
  useFinanceStream({ enabled, onInvalidate });
};
